import { Controller } from "@hotwired/stimulus"

// Panel "Moduły" (mega-menu, wariant 1a): live-filtrowanie modułów i podpozycji z podświetlaniem
// trafień, licznik widocznych modułów, pusty stan oraz autofokus pola po otwarciu dropdownu.
// Filtr: trafienie w nazwę modułu -> moduł z wszystkimi podpozycjami; trafienie tylko w podpozycje
// -> moduł z pasującymi podpozycjami; brak -> moduł ukryty; kategoria bez modułów -> ukryta.
export default class extends Controller {
  static targets = ["input", "count", "empty", "emptyQuery", "group", "item", "name", "chip"]
  static values = { countSuffix: String }

  connect() {
    this._observeOpen()
    this.filter()
    this._focusIfVisible()
  }

  disconnect() {
    if (this._observer) this._observer.disconnect()
  }

  // Ustawia focus w polu wyszukiwania gdy dropdown (przodek [data-dropdown-target=menu]) się pokaże.
  _observeOpen() {
    const menu = this.element.closest("[data-dropdown-target='menu']")
    if (!menu) return
    this._menu = menu
    this._observer = new MutationObserver(() => this._focusIfVisible())
    this._observer.observe(menu, { attributes: true, attributeFilter: ["class"] })
  }

  _focusIfVisible() {
    const hidden = this._menu && this._menu.classList.contains("hidden")
    if (!hidden && this.hasInputTarget) {
      setTimeout(() => this.inputTarget.focus(), 60)
    }
  }

  filter() {
    const q = (this.hasInputTarget ? this.inputTarget.value : "").trim().toLowerCase()
    let visible = 0

    this.itemTargets.forEach(item => {
      const name = item.dataset.name || ""
      const nameHit = q !== "" && name.toLowerCase().includes(q)
      let chipHits = 0

      item.querySelectorAll("[data-module-menu-target='chip']").forEach(chip => {
        const label = chip.dataset.chipName || ""
        const show = q === "" || nameHit || label.toLowerCase().includes(q)
        chip.classList.toggle("hidden", !show)
        if (show && q !== "" && !nameHit) chipHits++
        this._highlight(chip, label, (q !== "" && !nameHit) ? q : "")
      })

      const show = q === "" || nameHit || chipHits > 0
      item.classList.toggle("hidden", !show)
      if (show) visible++

      const nameEl = item.querySelector("[data-module-menu-target='name']")
      this._highlight(nameEl, name, nameHit ? q : "")
    })

    // ukryj kategorie bez widocznych modułów
    this.groupTargets.forEach(group => {
      const anyVisible = group.querySelector("[data-module-menu-target='item']:not(.hidden)")
      group.classList.toggle("hidden", !anyVisible)
    })

    if (this.hasCountTarget) this.countTarget.textContent = `${visible} ${this.countSuffixValue}`.trim()
    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle("hidden", visible > 0)
    if (this.hasEmptyQueryTarget) this.emptyQueryTarget.textContent = q ? this.inputTarget.value.trim() : ""
  }

  // Podświetla trafienie w tekście (owija dopasowany fragment w <mark>). Buduje węzły ręcznie - bez XSS.
  _highlight(el, text, term) {
    if (!el) return
    if (!term) { el.textContent = text; return }

    const i = text.toLowerCase().indexOf(term)
    if (i < 0) { el.textContent = text; return }

    el.textContent = ""
    el.appendChild(document.createTextNode(text.slice(0, i)))
    const mark = document.createElement("mark")
    mark.textContent = text.slice(i, i + term.length)
    el.appendChild(mark)
    el.appendChild(document.createTextNode(text.slice(i + term.length)))
  }
}
